module.exports = __webpack_public_path__ + "media/2.2_tabla_8_cf1.6ee5afce.wav";